"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumEventName = void 0;
/**
 * These are legacy page view and click events that will eventually get replaced auto-tracking while others are one-off custom events.
 * @export
 * @enum {string}
 */
exports.EnumEventName = {
    AboutVitalSelect: 'AboutVitalSelect',
    AddConditionNext: 'AddConditionNext',
    AddConditionSave: 'AddConditionSave',
    AddConditionStart: 'AddConditionStart',
    AddContactSave: 'AddContactSave',
    AddContactStart: 'AddContactStart',
    AddDocumentSave: 'AddDocumentSave',
    AddDocumentStart: 'AddDocumentStart',
    AddImportantVital: 'AddImportantVital',
    AddPeopleSelection: 'AddPeopleSelection',
    AddPharmacySelection: 'AddPharmacySelection',
    AddPhysicianSelection: 'AddPhysicianSelection',
    AddPrescriptionSave: 'AddPrescriptionSave',
    AddPrescriptionStart: 'AddPrescriptionStart',
    AddProfile: 'AddProfile',
    AddTaskStart: 'AddTaskStart',
    AddVitalReminder: 'AddVitalReminder',
    AddVitalSave: 'AddVitalSave',
    AddVitalStart: 'AddVitalStart',
    AdlAssessmentSave: 'ADLAssessmentSave',
    AdlAssessmentSkip: 'ADLAssessmentSkip',
    AdlAssessmentStart: 'ADLAssessmentStart',
    AdlAssessmentCancel: 'ADLAssessmentCancel',
    ChangeLocation: 'ChangeLocation',
    ChangeProfileCancel: 'ChangeProfileCancel',
    ChangeProfileSelect: 'ChangeProfileSelect',
    ChangeProfileTap: 'ChangeProfileTap',
    ClientError: 'CLIENT_ERROR',
    CompleteTask: 'CompleteTask',
    ConnectContact: 'ConnectContact',
    ConsumerHealthDataConsent: 'ConsumerHealthDataConsent',
    ContactsTabOpen: 'ContactsTabOpen',
    ContactsTabAddOpen: 'ContactsTabAddOpen',
    ContactsTabEditOpen: 'ContactsTabEditOpen',
    ContactsTabDetailOpen: 'ContactsTabDetailOpen',
    ContactsTabPeopleOpen: 'ContactsTabPeopleOpen',
    DashboardAdd: 'DashboardAdd',
    DashboardAddType: 'DashboardAddType',
    DeleteAccount: 'DeleteAccount',
    DeleteDocument: 'DeleteDocument',
    DeleteTask: 'DeleteTask',
    DiscardPrescription: 'DiscardPrescription',
    DocumentsTabOpen: 'DocumentsTabOpen',
    DocumentsTabEditOpen: 'DocumentsTabEditOpen',
    EditContact: 'EditContact',
    EditDateTime: 'EditDateTime',
    EditReminder: 'EditReminder',
    EditRepeat: 'EditRepeat',
    EditTaskStart: 'EditTaskStart',
    FavoriteDocument: 'FavoriteDocument',
    HomeTabOpen: 'HomeTabOpen',
    IncompleteTask: 'IncompleteTask',
    InvalidAccessToken: 'InvalidAccessToken',
    Login: 'Login',
    Logout: 'Logout',
    MainFtueView: 'MainFtueView',
    MedicationListOpen: 'MedicationListOpen',
    MedicationScheduleOpen: 'MedicationScheduleOpen',
    MedicationsTabOpen: 'MedicationsTabOpen',
    MoreTabOpen: 'MoreTabOpen',
    NetworkError: 'NETWORK_ERROR',
    NextPrescriptionAction: 'NextPrescriptionAction',
    OnboardingAdlView: 'OnboardingADLView',
    OnboardingCaringForView: 'OnboardingCaringForView',
    OnBoardingComplete: 'OnBoardingComplete',
    OnboardingConditionView: 'OnboardingConditionView',
    OnboardingRecipientDetails: 'OnboardingRecipientDetails',
    OnboardingRecipientDetailsView: 'OnboardingRecipientDetailsView',
    PostScreeningSetupFailed: 'PostScreeningSetupFailed',
    ProfileViewOpen: 'ProfileViewOpen',
    RecommendationComplete: 'RecommendationComplete',
    RecommendedArticleSelected: 'RecommendedArticleSelected',
    RecommendedTaskSelected: 'RecommendedTaskSelected',
    RegistrationComplete: 'RegistrationComplete',
    RegistrationEmailPw: 'RegistrationEmailPW',
    RegistrationName: 'RegistrationName',
    RegistrationStart: 'RegistrationStart',
    DependentRegistrationError: 'DependentRegistrationError',
    RegistrationCountryError: 'RegistrationCountryError',
    RemoveContact: 'RemoveContact',
    RemoveDocumentFilter: 'RemoveDocumentFilter',
    RemoveImportantVital: 'RemoveImportantVital',
    RemoveProfile: 'RemoveProfile',
    RemoveVital: 'RemoveVital',
    RemoveVitalReminder: 'RemoveVitalReminder',
    ResourcesTabOpen: 'ResourcesTabOpen',
    SearchResultsShown: 'Search : Results : Shown',
    SearchFlaggedResultsShown: 'Search : Flagged Results : Shown',
    SearchSuggestionsShown: 'Search : Suggestions : Shown',
    SelectDocumentFilter: 'SelectDocumentFilter',
    ServerError: 'SERVER_ERROR',
    SettingsTabOpen: 'SettingsTabOpen',
    ShareMedicationList: 'ShareMedicationList',
    SkipPrescriptionAction: 'SkipPrescriptionAction',
    TaskSave: 'TaskSave',
    TasksTabOpen: 'TasksTabOpen',
    UnfavoriteDocument: 'UnfavoriteDocument',
    UserAccountEditBioAdd: 'UserAccountEditBioAdd',
    ViewContact: 'ViewContact',
    ViewDocument: 'ViewDocument',
    ViewEssentialDocumentList: 'ViewEssentialDocumentList',
    ViewPrescription: 'ViewPrescription',
    WebPageLoadMetric: 'WebPageLoadMetric',
    WelcomeScreenView: 'WelcomeScreenView',
    VerifyEmailLater: 'VerifyEmailLater',
    EmailDelete: 'EmailDelete',
    DiscardData: 'DiscardData',
    InviteStart: 'InviteStart',
    RemoveFromCareTeam: 'RemoveFromCareTeam',
    InviteSend: 'InviteSend',
    CheckEssentialDocument: 'CheckEssentialDocument',
    InviteProfileSelector: 'InviteProfileSelector',
    MessagesReply: 'MessagesReply',
    MessagesReplyAll: 'MessagesReplyAll',
    MessagesCompose: 'MessagesCompose',
    MessagesPrint: 'MessagesPrint',
    MessagesMoveToTrash: 'MessagesMoveToTrash',
    MessagesMoveToInbox: 'MessagesMoveToInbox',
    MessagesAttachFile: 'MessagesAttachFile',
    MessagesSend: 'MessagesSend',
    MessagesDetail: 'MessagesDetail',
    MessagesTablePageForward: 'MessagesTablePageForward',
    MessagesTablePageBack: 'MessagesTablePageBack',
    MessagesTabImportantOpen: 'MessagesTabImportantOpen',
    MessagesTabInboxOpen: 'MessagesTabInboxOpen',
    MessagesTabComposeOpen: 'MessagesTabComposeOpen',
    MessagesTabSentOpen: 'MessagesTabSentOpen',
    MessagesTabTrashOpen: 'MessagesTabTrashOpen',
    MessagesTabDetailOpen: 'MessagesTabDetailOpen',
    CoveringApcStart: 'CoveringAPCStart',
    CoveringApcViewOpen: 'CoveringAPCViewOpen',
    CoveringApcMemberNext: 'CoveringAPCMemberNext',
    CoveringApcMemberCancel: 'CoveringAPCMemberCancel',
    CoveringApcacpNext: 'CoveringAPCACPNext',
    CoveringApcapcBack: 'CoveringAPCAPCBack',
    CoveringApcConfirmOk: 'CoveringAPCConfirmOk',
    CoveringApcConfirmBack: 'CoveringAPCConfirmBack',
    CoveringApcCancel: 'CoveringAPCCancel',
    CoveringApcRemoveAll: 'CoveringAPCRemoveAll',
    AfterVisitSummaryTabOpen: 'AfterVisitSummaryTabOpen',
    AfterVisitSummaryTabNewOpen: 'AfterVisitSummaryTabNewOpen',
    AfterVisitSummaryNewSave: 'AfterVisitSummaryNewSave',
    CareTeamTabOpen: 'CareTeamTabOpen',
    CareTeamTabDetailOpen: 'CareTeamTabDetailOpen',
    AuthErrorViewOpen: 'AuthErrorViewOpen',
    UnauthenticatedViewOpen: 'UnauthenticatedViewOpen',
    LoggedOutViewOpen: 'LoggedOutViewOpen',
    RegisterFromInvitationLink: 'RegisterFromInvitationLink',
    RegisterFromInvitationLinkRedirect: 'RegisterFromInvitationLinkRedirect',
    RegisterFromExistingInvitation: 'RegisterFromExistingInvitation',
    RegisterFromOther: 'RegisterFromOther',
    RedirectToExistingInvitation: 'RedirectToExistingInvitation',
    FilterSelectorOptionAdded: 'Filter Selector : Option : Added',
    FilterSelectorOptionRemoved: 'Filter Selector : Option : Removed',
    SearchQuerySubmitted: 'Search : Query : Submitted',
};
//# sourceMappingURL=enum-event-name.js.map